import { render, staticRenderFns } from "./BannerLeiloeiro.vue?vue&type=template&id=18c8a478&scoped=true"
import script from "./BannerLeiloeiro.vue?vue&type=script&lang=js"
export * from "./BannerLeiloeiro.vue?vue&type=script&lang=js"
import style0 from "./BannerLeiloeiro.vue?vue&type=style&index=0&id=18c8a478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c8a478",
  null
  
)

export default component.exports